import BulkNodesEditFormRow from "@features/builder/BulkNodesEditDialog/BulkNodesEditForm/BulkNodesEditFormRow"
import { AppNode } from "@features/builder/graph/types"
import { TableBody, TableCell, TableRow } from "@mui/material"
import { useVirtualizer } from "@tanstack/react-virtual"
import type { RefObject } from "react"

const TABLE_ROW_ESTIMATED_HEIGHT_PX = 58

type VirtualizedFormRowsProps = {
  nodes: AppNode[]
  tableContainerRef: RefObject<HTMLDivElement>
}

const VirtualizedFormRows = ({ nodes, tableContainerRef }: VirtualizedFormRowsProps) => {
  const rowVirtualizer = useVirtualizer({
    count: nodes.length,
    getScrollElement: () => tableContainerRef.current,
    estimateSize: () => TABLE_ROW_ESTIMATED_HEIGHT_PX,
    overscan: 10,
  })

  const virtualItems = rowVirtualizer.getVirtualItems()
  const paddingTop = virtualItems[0]?.start ?? 0
  const paddingBottom =
    virtualItems.length > 0
      ? rowVirtualizer.getTotalSize() - (virtualItems[virtualItems.length - 1]?.end ?? 0)
      : 0

  return (
    <TableBody>
      {paddingTop > 0 && (
        <TableRow>
          <TableCell sx={{ border: 0, p: 0, height: paddingTop }} />
        </TableRow>
      )}

      {virtualItems.map((virtualRow) => {
        const node = nodes[virtualRow.index]
        if (!node) return null

        return (
          <BulkNodesEditFormRow key={node.id} numericOrder={virtualRow.index + 1} node={node} />
        )
      })}

      {paddingBottom > 0 && (
        <TableRow>
          <TableCell sx={{ border: 0, p: 0, height: paddingBottom }} />
        </TableRow>
      )}
    </TableBody>
  )
}

export default VirtualizedFormRows
